var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGolfCartService = function SvgGolfCartService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.2 14.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M16.848 4.314c2.072 0 3.752 1.663 3.752 3.715v1.393c0 1.025-.84 1.857-1.876 1.857h-.469m-1.407-6.965L14.972.6m1.876 3.714h-1.876v2.322H10.75V4.314H8.406M1.84 9.422V4.314h2.345M1.84 9.422c0 1.025.84 1.857 1.876 1.857h.469M1.84 9.422H.6m3.585 1.857c0 1.282 1.05 2.321 2.345 2.321s2.345-1.04 2.345-2.321m-4.69 0c0-1.282 1.05-2.322 2.345-2.322s2.345 1.04 2.345 2.322m0 0h4.69m0 0c0 1.282 1.05 2.321 2.345 2.321s2.345-1.04 2.345-2.321m-4.69 0c0-1.282 1.05-2.322 2.345-2.322s2.345 1.04 2.345 2.322M4.185 4.314V.6m0 3.714h4.22m0 0V.6"
  })));
};
export default SvgGolfCartService;